var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3AirflowOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.82 35.88L76 0h-5.22L53.3 18.77 30.83 42.9 0 76h5.45L36.1 43.09a5 5 0 106.72-7.21z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.79 36.1h7.67c9.23.09 9.44 9.27 9.44 9.76.07 5.14-3.4 7.91-6.93 7.91-5.32.03-6.61-5.49-8.61-9.25a5.209 5.209 0 00-1.27-1.37 9.6 9.6 0 00-.3-7.05zM45.78 14.01a8.46 8.46 0 015.1 1.5S36.12 31.44 36.01 31.48V23.7c-.06-9.47 9.28-9.69 9.77-9.69zM36.88 49.08a.113.113 0 01-.004.006 9.58 9.58 0 006.984-.256v7.47c.07 9.47-9.27 9.69-9.76 9.69-5.14.07-7.91-3.4-7.91-6.93-.04-5.33 5.49-6.62 9.25-8.62a4.928 4.928 0 001.436-1.354 1.015 1.015 0 01-.016-.006h.02z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Airflow_off.e704675a.svg";
export { SvgB3AirflowOff as ReactComponent };